import reducer from './reducers';

import * as moduleOperations from './operations';

export {
    moduleOperations
};

export default reducer;
